import { NotificacoesContext } from '@/context/Notificacoes'
import { useContext } from 'react'

export function useNotificacoes() {
    return useContext(NotificacoesContext)
}
